import React, { FC } from 'react';
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
  concat,
} from '@apollo/client';
import { StoreInstance } from '../../index';

const envMiddleware = new ApolloLink((operation: any, forward: any) => {
  const state = StoreInstance.getState();
  const { token } = state.analytics.analytics;
  const referer = window.location.origin + window.location.hash.substr(1);

  let headers: any = {
    'x-forwarded-referer': referer,
    env: process.env.REACT_APP_API_ENVIRONMENT,
  };

  if (token) {
    headers = { ...headers, Authorization: `Bearer ${token}` };
  }

  operation.setContext({
    headers,
  });

  return forward(operation);
});
const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL });
const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL,
  cache: new InMemoryCache(),
  link: concat(envMiddleware, httpLink),
});

interface Props {
  children: any;
}

const ApolloRootProvider: FC<any> = ({ children }: Props) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);

export default ApolloRootProvider;
try {
    // @ts-ignore
    ApolloRootProvider.displayName = "ApolloRootProvider";
    // @ts-ignore
    ApolloRootProvider.__docgenInfo = { "description": "", "displayName": "ApolloRootProvider", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/hoc/Apollo/ApolloRootProvider.tsx#ApolloRootProvider"] = { docgenInfo: ApolloRootProvider.__docgenInfo, name: "ApolloRootProvider", path: "src/hoc/Apollo/ApolloRootProvider.tsx#ApolloRootProvider" };
}
catch (__react_docgen_typescript_loader_error) { }